import { PureLightTheme } from "../../../../styles/theme"

export const BoxTabs = {
    width: "100%",
    marginBottom: 2,
    [PureLightTheme.breakpoints.down('sm')]: {
        width: "calc(100% + 24px)",
        margin: "0px -12px 16px",
    }
}

export const TabsStyle = {
    width: "100%",
    position: 'relative',
    '& .MuiTabScrollButton-root': {
        position: 'absolute',
        zIndex: 1,
        height: '100%',
    },
    '& .MuiTabScrollButton-root:first-of-type': { 
        left: 0,
    },
    '& .MuiTabScrollButton-root:last-of-type': { 
        right: 0,
    },
}

export const ImageTab = {
    height: "auto",
    padding: 0,
    border: "none",
    backgroundColor: "inherit",
    cursor: "pointer",
}

export const ImageItem = {
    width: "146px", 
    height: "100px", 
    borderRadius: "12px", 
    objectFit: "cover", 
}

export const CardDescription = {
    overflowWrap: 'anywhere',
}

export const TypTitle = {
    marginBottom: 1,

    [PureLightTheme.breakpoints.down("sm")]: {
        marginBottom: 0.5,
    }
}

export const shortDescriptionClampText = {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}